/**
 * <StudentCoachSkeleton> — la forme de « Messages » pendant son premier chargement.
 *
 * Le cas courant : « Mon tuteur », un seul. Les vraies surfaces et les intitulés qui ne dépendent
 * d'aucune donnée restent.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Title } from "../../atoms/typography/Title"
import { REFRESH_BUTTON_SIZE } from "../../molecules/RefreshButton"
import { TutorTeamSectionSkeleton } from "../../templates/TutorTeamSection"

export type StudentCoachSkeletonProps = {
    /** La place du bouton de relecture, à droite du titre. Défaut `true` ; la page la retire sans bouton. */
    titleActions?: boolean
}

export function StudentCoachSkeleton(props: StudentCoachSkeletonProps) {
    const { titleActions = true } = props
    return (
        <Stack gap="6">
            <Row justify="between" align="center">
                <Title size="text-2xl">Messages</Title>
                {titleActions && <View style={styles.titleActions} />}
            </Row>

            <TutorTeamSectionSkeleton />
        </Stack>
    )
}

const styles = StyleSheet.create(() => ({
    // La cible du bouton de relecture : la barre de titre ne change pas de hauteur à son arrivée.
    titleActions: { width: REFRESH_BUTTON_SIZE, height: REFRESH_BUTTON_SIZE },
}))
